import { combineReducers } from 'redux';

import errors from './errors';

import {
  ACTION_LOAD_BALANCE__SUCCESS,
  ACTION_LOAD_BALANCE_SUMMARY__SUCCESS,
  ACTION_LOAD_WEBMASTER_PROFILE__SUCCESS,
  ACTION_LOAD_WEBMASTER_PROFILE__FAIL,
  ACTION_EDIT_WEBMASTER_PROFILE__SUCCESS,
} from '../actionTypes';


const balance = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_BALANCE__SUCCESS:
      return action.payload.result;

    default:
      return state;
  }
};

const balanceSummary = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_BALANCE_SUMMARY__SUCCESS:
      return action.payload.result;

    default:
      return state;
  }
};

const profile = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_WEBMASTER_PROFILE__SUCCESS:
    case ACTION_EDIT_WEBMASTER_PROFILE__SUCCESS:
      return action.payload.result;

    case ACTION_LOAD_WEBMASTER_PROFILE__FAIL:
      return null;

    default:
      return state;
  }
};

export default combineReducers({
  balance,
  balanceSummary,
  profile,
  errors,
});
